export default __webpack_public_path__ + "static/media/tray-placeholder.bac88945.svg";